/**
 * バリデーションエラー文言
 */
const _messages = new Map([
  ["required", "{0}を入力してください。"],
  ["email", "正しいメールアドレスの形式で入力してください。"],
  ["minLength", "{0}は{1}文字以上で入力してください。"],
  ["maxLength", "{0}は{1}文字以内で入力してください。"],
  ["alpha", "{0}で使用できる文字は半角英字のみです。"],
  ["alphaNum", "{0}で使用できる文字は半角英数字のみです。"],
  ["numeric", "{0}は半角数字のみで入力してください。"],
  ["justLength", "{0}は{1}桁で入力してください。"],
  ["between", "{0}は{1}~{2}の範囲で入力してください。"],
  ["selected", "{0}を選択してください。"],
  ["verifyPassword", "確認用にもう一度入力してください"], // パスワード再確認欄未入力
  ["OnebyOne", "{0}は英小文字、英大文字、数字を混在して入力してください。"], //パスワードにおける種類不足の場合
])

const _errorMessages = new Map([
  /**
  * auth error
  */
  ["auth/email-already-in-use", "このメールアドレスはご利用いただけません。"], // メールアドレスが既に使用済み
  ["auth/invalid-email", "メールアドレスの形式が正しくありません。"], // メールアドレスの形式が不正
  ["auth/user-not-found", "メールアドレスまたはパスワードが間違っております。"], // メールアドレスが存在しない
  ["auth/user-not-found2", "メールアドレスが間違っております。"], // メールアドレスが存在しない(またはパスワードの文言なし)
  ["auth/invalid-password", "メールアドレスまたはパスワードが間違っております。"], // パスワード形式不正
  ["auth/wrong-password", "メールアドレスまたはパスワードが間違っております。"], //パスワード不一致
  ["auth/too-many-requests", "ログインの失敗回数が多すぎます。後でもう一度やり直してください。"], //複数回失敗
  ["auth/user-disabled", "このIDではログインできません。"], //ユーザーIDが無効化されている
  ["auth/weak-password", "パスワードは8文字以上にしてください。"], // パスワード桁数エラー
  ["auth/internal-error", "認証サーバーで予期しないエラーが発生しました。"],

  /**
  * common error
  */
  ["validation-error", "エラー項目があります。入力項目を確認してください。"], //バリデーションエラー
  ["other", "ただいま大変込み合っております。しばらく経ってから再度お試しください"], // 想定外

  /**
   * 固有系
   */
  ["send-mail-failed", "メールの送信に失敗しました。"], // 確認メール送信失敗
  ["send-comment-failed", "コメントの投稿に失敗しました。"], // コメント投稿失敗
  ["delete-comment-failed", "コメントの削除に失敗しました。"], // コメント削除失敗
  ["room-not-exists", "このトークルームは存在しません。"], // 指定されたトークルーム存在なし
  ["not-selected-id", "不正な画面遷移です。トーク一覧に戻ります。"], // id指定されずルームを表示した場合
  ["email-verification-error", "メール送信でエラーが発生しました。"], //メール確認エラー
  ["create-room-failed", "ルーム作成に失敗しました"], // ルーム作成に失敗
  ["update-room-failed", "ルーム更新に失敗しました"], // ルーム更新に失敗
  ["delete-room-failed", "ルーム削除に失敗しました"], // ルーム削除に失敗
  ["not-match-password", "入力されたパスワードが一致していません。"], // パスワードと確認用パスワードで入力された値が不一致
  ["not-publish-job", "この仕事紹介は終了しました。一覧に戻ります。"], // 指定された仕事IDが存在しない場合

])


export default {
  data() {
    return {
      messages: _messages,
      errorMessages: _errorMessages,
    }
  },
  methods: {
    /**
     * バリデーションエラー時のメッセージ取得
     * 
     * @param o バリデーションオブジェクト 
     * @param arg メッセージに埋める文字列オブジェクト
     */
    getMessage(o, arg) {
      if ("required" in o && !o.required) {
        return this.messages.get("required")
          .replace("{0}", arg.name)
      }
      else if ("email" in o && !o.email) {
        return this.messages.get("email")
      }
      else if ("minLength" in o && !o.minLength) {
        return this.messages.get("minLength")
          .replace("{0}", arg.name)
          .replace("{1}", o.$params.minLength.min)
      }
      else if ("maxLength" in o && !o.maxLength) {
        return this.messages.get("maxLength")
          .replace("{0}", arg.name)
          .replace("{1}", o.$params.maxLength.max)
      }
      else if ("alpha" in o && !o.alpha) {
        return this.messages.get("alpha")
          .replace("{0}", arg.name)
      }
      else if ("alphaNum" in o && !o.alphaNum) {
        return this.messages.get("alphaNum")
          .replace("{0}", arg.name)
      }
      else if ("numeric" in o && !o.numeric) {
        return this.messages.get("numeric")
          .replace("{0}", arg.name)
      }
      else if ("justLength" in o && !o.justLength) {
        return this.messages.get("justLength")
          .replace("{0}", arg.name)
          .replace("{1}", arg.len)
      }
      else if ("between" in o && !o.between) {
        return this.messages.get("between")
          .replace("{0}", arg.name)
          .replace("{1}", o.$params.between.min)
          .replace("{2}", o.$params.between.max)
      }
      else if ("selected" in o && !o.selected) {
        return this.messages.get("selected")
          .replace("{0}", arg.name)
      }
      else if ("verifyPassword" in o && !o.verifyPassword) {
        return this.messages.get("verifyPassword")
      }
      else if ("match" in o && !o.match) {
        return this.messages.get(arg.type)
          .replace("{0}", arg.name)
      }
    },
    /**
     * エラーメッセージ取得
     * 
     * @param code エラーコード 
     * @param arg メッセージに埋める文字列
     */
    getErrorMessage(code, arg) {
      var mes = this.errorMessages.get(code)
      if (this.isEmpty(mes)) {
        return this.errorMessages.get("other")
      }
      return mes.replace("{0}", arg)
    }
  },
}